import { Intent } from "@focus/focusUI";
import { useDispatch } from "react-redux";
import { showNotification } from "../../store/toasterDuck";
import type { ContactFormState } from "../../types/questionnaires";
import { fetchWithAuth } from "../helpers/api";

/**
 *
 * @param data
 */
export const sendQuestionnarie = async (data: ContactFormState) => {
  const response = await fetchWithAuth(
    "/mailing-service/api/v1/questionnaire",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    },
  );

  if (!response.ok) {
    useDispatch()(
      showNotification({
        message: "Error sending questionnaire",
        intent: Intent.DANGER,
      }),
    );
    console.error("Error sending questionnaire:", response.status);
  }
};
